/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('product');
const PRODUCT_LIST = "PRODUCT_LIST";
const PRODUCT_ADD = "PRODUCT_ADD";
const PRODUCT_DELETE = "PRODUCT_DELETE";
const PRODUCT_EDIT = "PRODUCT_EDIT";
const PRODUCT_DETAIL = "PRODUCT_DETAIL"; 

export default {
    PRODUCT_LIST,
    productList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:PRODUCT_LIST,
                data
            })
        })
    },
    PRODUCT_ADD,
    productAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:PRODUCT_ADD,
                data
            })
        })
    },
    PRODUCT_DELETE,
    productDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:PRODUCT_DELETE,
                data,
            })
        })
    },
    PRODUCT_EDIT,
    productEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:PRODUCT_EDIT,
                data,
            })
        })
    },
    PRODUCT_DETAIL,
    productDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:PRODUCT_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/ProductAction.js